import React from "react";
export default ({ width='35px', height='35px', backgroundSize='initial'}) => {
    return (
        <div style={{ width, height,  background: 'url(/img/cargando.gif)',backgroundSize }}></div>
    )
} 